/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, borderRadius, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

export const BranchesAndState = styled.div(
  {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
  },
  media.upToXLarge(`flex-wrap: wrap;`)
);

const originalTagMaxWidth = '180';

export const BranchLabel = styled.span({
  background: token('color.background.input', colors.N20),
  borderRadius: `${borderRadius()}px`,
  color: token('color.text.subtle', colors.N500),
  cursor: 'default',
  display: 'inline-block',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 1,
  maxWidth: `${originalTagMaxWidth}px`,
  overflow: 'hidden',
  padding: `${gridSize() / 2}px ${gridSize()}px`,
  textOverflow: 'ellipsis',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
});

export const ItemWrapper = styled.div({
  marginRight: `${gridSize() / 2}px`,
});
